import './TradingBanner.scss';
import { useTranslation } from 'react-i18next';
import { app } from '../../../../data/AppController';
import { assets } from '../../../../assets/assets';

export const TradingBanner = () => {
  const { t } = useTranslation();

  const onClick = () => {
    app.nav.goTo('TradingPage');
    // app.ui.drawer.show({
    //   id: 'generic',
    //   opts: {
    //     title: t('modal_temp_closed_title'),
    //     subtitle: t('modal_temp_closed_description'),
    //     image: assets.sloth_gift_invalid,
    //   },
    // });
  };

  return (
    <div className={`btn trading-banner`} onClick={onClick}>
      <div className="trading-banner-bg" />

      <div className="trading-banner-new">{t('trading_banner_new')}</div>

      <div className="trading-banner-content">
        <div className="trading-banner-cup" />

        <div className="trading-banner-info">
          <div className="trading-banner-info-top">
            <div className="title">{t('trading_banner_title')}</div>
            {/* <div className="btn info-button">
              <img src={assets.powerup_daily_info} />
            </div> */}
          </div>
          <div className="trading-banner-info-bottom">
            <div className="owned">
              {t('trading_banner_owned', {
                amount: app.trading.myOffchainTokensCount,
              })}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
